import 'semantic-ui-flag/flag.css'
import 'semantic-ui-flag/assets/images/flags.png'

const Flag = ({ country }: { country: string }) => {
  return <i className={`flag ${country?.toLowerCase()}`} />
}

export default Flag
